import { Bot, Clock, FileText, Landmark, Merge, Phone, ShieldCheck, TriangleAlert, UserRound, Users } from 'lucide-react'
import { cn } from 'cn'
import type { AppIcon } from '@/lib/services'

/** Apps the example runs through: their logos live in `public/site/assets/apps/`. */
const APPS: Partial<Record<AppIcon, string>> = {
  whatsapp: 'WhatsApp',
  sap: 'SAP',
  excel: 'Excel',
  outlook: 'Outlook',
}

const GLYPHS = {
  bank: Landmark,
  phone: Phone,
  warning: TriangleAlert,
  agent: Bot,
  match: Merge,
  person: UserRound,
  document: FileText,
  rules: ShieldCheck,
  people: Users,
  clock: Clock,
} as const

/**
 * A step's icon on a rounded tile: an app's logo on a light tile (so its
 * colours hold in both themes; its alt text names the app), or a plain
 * glyph drawn in the text colour, amber for a step that breaks the flow.
 */
export function AppTile({ icon, className }: { icon: AppIcon; className?: string }) {
  const app = APPS[icon]
  if (app) {
    return (
      <span className={cn('de-tile de-tile--app', className)}>
        {/* eslint-disable-next-line @next/next/no-img-element -- small static SVG logo */}
        <img src={`/site/assets/apps/${icon}.svg`} alt={app} width={24} height={24} />
      </span>
    )
  }
  const Glyph = GLYPHS[icon as keyof typeof GLYPHS]
  return (
    <span className={cn('de-tile', icon === 'warning' && 'de-tile--warning', className)}>
      <Glyph aria-hidden="true" strokeWidth={1.75} />
    </span>
  )
}
